import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-monthly-bill-abstract',
  templateUrl: './monthly-bill-abstract.component.html',
  styleUrls: ['./monthly-bill-abstract.component.scss']
})
export class MonthlyBillAbstractComponent implements OnInit {
  from_date: any;
  to_date: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;
  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    console.log(data_dict);
    this.document_file = null;
    this.is_document_available = false;
    this.httpService.serveMonthlyBillAbstract(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
